import { breakpoints, customScrollMinimal } from '@toggle/design-system';
import styled from 'styled-components';

export const ViewRoot = styled.div`
  display: flex;
  min-height: calc(100% - var(--app-header-height));
  height: calc(100% - var(--app-header-height));

  ${customScrollMinimal} /* warning - must be minimum 100% */

  @media ${breakpoints['max-sm']} {
    height: 100%;
    overflow: hidden;
  }
`;
